/** Shared copy for mail / check order flows (admin orders + checkout). */

export const MAIL_ORDER_MODAL_TITLE = 'New mail / check order';

export const MAIL_ORDER_MODAL_SUBTITLE =
  'Create an order at customer price or 🏢 wholesale pricing — then email an invoice.';

export const MAIL_ORDER_ACTION_LABEL = '✉️ New mail / check order';

export const MAIL_ORDER_PRICING_RETAIL_LABEL = 'Customer price';
export const MAIL_ORDER_PRICING_WHOLESALE_LABEL = '🏢 Wholesale pricing';

/** Mail orders use the standard tier from each product's wholesale settings. */
export const MAIL_ORDER_WHOLESALE_TIER = 'standard';

export const MAIL_ORDER_CHECKOUT_PREFILL_HINT =
  'Pre-filled from checkout cart — review customer, line items, and pricing before submitting.';

export const MAIL_ORDER_MODE_LIVE = 'live';
export const MAIL_ORDER_MODE_TEST = 'test';

export const MAIL_ORDER_MODE_OPTIONS = [
  { value: MAIL_ORDER_MODE_LIVE, label: 'Live mail order', hint: 'Real customer order — appears in reports and counts as production.' },
  { value: MAIL_ORDER_MODE_TEST, label: 'Test mail order', hint: 'Practice run only — order number prefixed TEST; invoice emails marked [TEST].' },
];
